import { render } from "./CreatePasskeyPopup.vue?vue&type=template&id=cb9d85b6&scoped=true"
import script from "./CreatePasskeyPopup.vue?vue&type=script&lang=js"
export * from "./CreatePasskeyPopup.vue?vue&type=script&lang=js"

import "./CreatePasskeyPopup.vue?vue&type=style&index=0&id=cb9d85b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9d85b6"]])

export default __exports__